export default {
    steps: {
        entries: {
            title: 'First entries',
            action: 'Say what to add',
            what: 'Say or type what you have planned today — the assistant will lay it out in the planner.',
            why: 'The planner shows your whole day on one timeline: meetings, tasks, meals, sleep and workouts.',
        },
        calendar: {
            title: 'Google Calendar',
            action: 'Connect',
            what: 'Connect your Google Calendar.',
            why: 'Meetings from your calendar will sit in the planner next to the rest of your day — no copying over.',
        },
        profile: {
            title: 'Profile',
            action: 'Fill in',
            what: 'Gender, weight and height — all optional.',
            why: 'Your gender lets us address you properly, and weight and height help with meals and fitness.',
        },
        phone: {
            title: 'Rountine on your phone',
            action: 'How to do it',
            what: 'Add Rountine to your phone’s home screen — it opens like an app.',
            why: 'Keep the planner at hand during the day: tick off a task and dictate an entry on the go.',
        },
    },
    tiles: {
        assistant: { label: 'Assistant', hint: 'Conversation' },
        planner: { label: 'Planner', hint: 'Day' },
        planer2Tasks: { label: 'Tasks', hint: 'Planner' },
        basket: { label: 'Groceries', hint: 'To buy' },
        shopping: { label: 'Shopping list', hint: 'Old shopping' },
        notes: { label: 'Notes', hint: 'Notes' },
        places: { label: 'Places', hint: 'Map' },
        wallet: { label: 'Wallet', hint: 'Left to spend' },
        walletPlans: { label: 'Payments', hint: 'Wallet' },
        walletTransactions: { label: 'Transactions', hint: 'Wallet' },
        meals: { label: 'Meals', hint: 'Old Food' },
        mealPlan: { label: 'Meal plan', hint: 'Old Food' },
        foodToday: { label: 'Food', hint: 'Today' },
        forma: { label: 'Fitness', hint: 'Now' },
        sleep: { label: 'Sleep', hint: 'Fitness' },
        weight: { label: 'Weight', hint: 'Fitness' },
        projects: { label: 'Projects', hint: 'Tasks' },
        people: { label: 'People', hint: 'Birthdays and gifts' },
        pets: { label: 'Pets', hint: 'Vaccinations and weight' },
        devices: { label: 'Devices', hint: 'Services and warranties' },
        habits: { label: 'Habits', hint: 'Tick off today' },
        medications: { label: 'Medications', hint: 'Today’s doses' },
        expenses: { label: 'Expenses', hint: 'Finances' },
    },
    screen: {
        close: 'Close',
        greeting: {
            night: 'Good night',
            morning: 'Good morning',
            afternoon: 'Hello',
            evening: 'Good evening',
        },
        greetingNamed: '{greeting}, {name}',
        question: 'What would you like to open?',
        record: 'Tell the assistant',
        recordHint: 'What you do, eat, spend or plan — it saves the rest.',
        quickHeading: 'QUICK START',
        quick: 'Quick start',
        customise: 'Customise',
        allModules: 'ALL MODULES',
        showOnOpen: 'Show when the app opens',
    },
};
